import React from 'react';
import { css } from '@emotion/react';
import { ToggleGroup, ToggleGroupItem } from '@onward-delivery/design/toggle-group';
import { DesignScope } from '../../blocks';
import { colors, typography } from '@/styles';

import { DAY_NAMES } from '@/utilities/resourceDays';
import { WEEKDAY_LABELS } from '../../constants';

// Radix's container chrome is a segmented bar; these are free-standing wrapping pills, so the
// border/background/padding come off.
const GROUP = 'flex-wrap gap-1.5 rounded-none border-0 bg-transparent p-0';
// Sized to match the timeframe pickers beside them: MUI's small outlined input is 40px tall, and
// `text-xs` (12px/16px) + 2px of border leaves 11px of vertical padding to get there.
//
// Everything else is scaled by that same 1.25 so the pill keeps its shape — width and the corner
// radius included. Bumping the height alone turns them into stretched rectangles.
const ITEM =
    'min-w-[65px] rounded-[20px] border border-[#d5d5d5] px-[13px] py-[11px] text-xs font-semibold text-[#4c4c4c]';

// Sunday-first, matching DAY_NAMES (index === getUTCDay) and the calendar's own week header.
export default function WeekdayPicker({ days, onToggle, error }) {
    const value = DAY_NAMES.filter((day) => !!days?.[day]);

    // Radix reports the whole next selection, but the caller's API is one day at a time.
    const handleChange = (next) => {
        const changed = DAY_NAMES.find((day) => next.includes(day) !== value.includes(day));

        if (changed) {
            onToggle(changed);
        }
    };

    return (
        <DesignScope>
            <ToggleGroup type="multiple" value={value} onValueChange={handleChange} className={GROUP}>
                {DAY_NAMES.map((day) => (
                    <ToggleGroupItem key={day} value={day} className={ITEM}>
                        {WEEKDAY_LABELS[day]}
                    </ToggleGroupItem>
                ))}
            </ToggleGroup>
            {error ? (
                <div
                    css={css`
                        ${typography.sansSerif}
                        font-size: 11px;
                        color: ${colors.reds.primary};
                        margin-top: 6px;
                    `}
                >
                    {typeof error === 'string' ? error : 'Pick at least one day.'}
                </div>
            ) : null}
        </DesignScope>
    );
}
